// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2z5We","inner":"Form_inner__31lvd","range":"Form_range__3Z6G8","name":"Form_name__3VbcF","actions":"Form_actions__1C9H3"};